<template>
  <!-- Main content -->
  <div class="row center-block">
    <div class="col-md-12">
      <div class="box">
        <!--<div class="box-header">-->
        <!--<h3 class="box-title">停賣列表</h3>-->
        <!--</div>-->
        <!-- /.box-header -->
        <div class="box-body form-inline">
          <div class="form-group" v-if="brandBrief.length > 1 && $route.name !== 'storeInfo'">
            <!-- <select class="form-control h-38" v-model="brandSelect">
              <option v-for="brand in brandBrief" :value="brand.value">
                {{brand.label}}
              </option>
            </select> -->
            <multiselect
              v-model="brandSelect"
              :options="brandBrief"
              :searchable="true"
              :allow-empty="false"
              :close-on-select="true"
              placeholder="== 品牌 =="
              :show-labels="false"
              :multiple="false"
              label="label"
              track-by="value"
            >
            </multiselect>
          </div>
          <div class="form-group">
            <select class="form-control h-38" v-model="yearSelect">
              <option v-for="year in yearList" :value="year.value">
                {{year.label}}
              </option>
            </select>
          </div>
          <span class="pull-right">
            <button class="btn btn-primary bt-explain" data-toggle="modal" data-target="#reportModal">
              <i class="fa fa-question-circle mr-5" ></i>報表欄位說明
            </button>
          </span>
          <div class="col-xs-12" style="overflow: scroll; max-height: 500px;">
            <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
              <thead>
              <tr>
                <th class="th-fit">月份</th>
                <th>連結</th>
              </tr>
              </thead>
              <tbody v-if="isLoading">
                <tr>
                  <td colspan="12" class="text-center">資料讀取中......</td>
                </tr>
              </tbody>
              <tbody v-else-if="Object.keys(statementList).length > 0">
              <tr class="even" role="row" v-for="(statement, key) in statementList">
                <td>{{key}}</td>
                <td>
                  <a :href="statement" target="_blank">
                    點擊下載
                  </a>
                </td>
              </tr>
              </tbody>
              <tbody v-else-if="Object.keys(statementList).length === 0">
                <tr style="background-color: white">
                  <td rowspan="1" colspan="12" style="text-align: center; padding-bottom: 80px; padding-top:80px;">
                    <img src="/static/img/noMatchdata.svg" style="max-width: 148px;" class="center-block logo">
                    <span style="margin-bottom: 80px; color: #696969;">沒有符合的資料</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- /.box-body -->
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="reportModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
      <div class="modal-dialog modal-c" role="document">
        <div class="modal-content">
          <div class="modal-header border-b-1">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true"></span>
            </button>
            <h4 class="modal-title" id="myModalLabel">欄位說明</h4>
          </div>
          <div class="modal-body modal-content-c">
            <p> - 總會員數 : 曾訂購過的消費者人數</p>
            <p> - 總訂購人數 : 本月訂購過的人數</p>
            <p> - 總訂單數 : 狀態為已完成的(當月)訂單總數</p>
            <p> - 總訂單數(平台) : 從你訂網頁進入訂購 <a href="https://order.nidin.shop/">https://order.nidin.shop/</a> </p>
            <p> - 總訂單數(專屬) : 從品牌專屬網頁進入訂購</p>
            <p> - 總售出商品數 : 已完成狀態訂單下的所有售出商品數</p>
            <p> - 總商品金額 : 已完成狀態訂單下的所有商品的金額加總</p>
            <p> - 總銷售額 : 已完成狀態訂單下的實付總金額</p>
            <p> - 總錯誤筆數 : 產生報表時尚未處理的筆數(未被更新為已完成、可對應例外訂單)</p>
            <p> - 每日平均訂單數 : 總訂單數/月天數 </p>
            <p> - 訂單平均商品數 : 總訂單商品數/全部訂單數(所有訂單狀態「已接單」、「已完成」、「門市已取消」…等)</p>
            <p> - 訂單平均商品金額 : 總商品金額/全部訂單數(所有訂單狀態「已接單」、「已完成」、「門市已取消」…等)</p>
            <p> - 訂單平均銷售額 : 總銷售額/全部訂單數(所有訂單狀態「已接單」、「已完成」、「門市已取消」…等)</p>
          </div>
          <div class="modal-footer" style="display: flex; justify-content: center;">
            <button type="button" class="btn btn-default bt-c" data-dismiss="modal">關閉</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /.content -->
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  name: 'Tables',
  data () {
    return {
      roleType: 0,
      brandBrief: [],
      storeBrief: [],
      brandSelect: {
        value: 0,
        label: ''
      },
      storeSelect: 0,
      yearSelect: 2018,
      currentYear: 2018,
      statementList: [],
      expSecs: 0,
      timer: 0,
      isLoading: true
    }
  },
  mounted () {
  },
  methods: {
    getBrandBrief () {
      var self = this
      var url = '/brand/listBrief?is_delete=0&is_opening=1&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            self.brandBrief.push(obj)
            if (i === 0) self.brandSelect = obj
          }
        }
      })
    },
    getStoreBrief (brandId) {
      this.storeBrief = []
      var self = this
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
            if (i === 0) {
              self.storeSelect = obj.value
            }
          }
        }
      })
    },
    getBrandStatement () {
      this.isLoading = true
      var self = this
      var url = '/statistic/brandMonthlyStatement?brand_id=' + this.brandSelect.value + '&year=' + this.yearSelect
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.statementList = response.data.download_info.links
          self.expSecs = response.data.download_info.meta.acl_limit
          if (self.timer) clearInterval(self.timer)
          self.afterGet()
          self.isLoading = false
        }
      })
    },
    afterGet () {
      var self = this
      var num = this.expSecs
      this.timer = window.setInterval(function () {
        num = num - 1
        self.expSecs = num
      }, 1000)
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    fixedH () {
      return this.$parent.fixedH
    },
    yearList () {
      var currentYear = parseInt(moment().format('YYYY'), 10)
      this.currentYear = this.yearSelect = currentYear
      if (currentYear > 2017) {
        var list = []
        for (var i = currentYear; i >= 2017; i--) {
          var o = {
            label: i.toString(),
            value: i
          }
          if (i === currentYear) this.yearSelect = i
          list.push(o)
        }
        return list
      } else {
        return [{
          label: '2017',
          value: 2017
        }]
      }
    }
  },
  created () {
    this.roleType = parseInt(this.getRoleType, 10)
    this.fixedH()
    this.getBrandBrief()
  },
  watch: {
    'brandSelect.value' () {
      // this.getStoreBrief(this.brandSelect)
      if (this.brandSelect.value) this.getBrandStatement()
    },
    yearSelect () {
      if (this.yearSelect && this.brandSelect.value) this.getBrandStatement()
    },
    expSecs () {
      if (this.expSecs === 1 && this.brandSelect.value) this.getBrandStatement()
    }
  }
}
</script>
<style lang="sass" scoped>
  .border-b-1
    border-bottom:  1px solid #e5e5e5
  .modal-c 
    width: 50%
  .modal-content-c 
    padding: 30px
  .bt-c
    border: 1px solid #E1E1E1
    border-radius: 2px
    padding: 8px 28px
  .mr-5
    margin-right: 5px
  .bt-explain
    padding: 8px 16px
</style>



// WEBPACK FOOTER //
// ChartShare.vue?693380aa